import React, { useState, useEffect, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { GET_AUDIT_LIST } from "../../constants";
import Loader from "../reusable Component/Loader";
import axios from "axios";
import { Button, Grid, useMediaQuery, useTheme } from "@mui/material";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import OpenDataListComponent from "./OpenDataList";
import ClosedDataListComponent from "./ClosedDataList";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
};

function AuditTabComponent() {
  const [value, setValue] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [loading, setLoading] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTraderClick = () => {
    navigate("/auditTraderList");
  };

  const handleInHouseClick = (e) => {
    e.preventDefault();
  };

  const [openCount, setOpenCount] = useState(0);
  const [closedCount, setClosedCount] = useState(0);

  return (
    <>
      {loading && <Loader open={loading} />}

      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab
          label={`Open (${openCount})`}
          id="tab-0"
          icon={<NewReleasesIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
        <Tab
          label={`Closed (${closedCount})`}
          id="tab-1"
          icon={<VerifiedIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <OpenDataListComponent
          setOpenCount={setOpenCount}
          setClosedCount={setClosedCount}
        ></OpenDataListComponent>
        {/* <AuditOpenList setLoading={setLoading}></AuditOpenList> */}
      </TabPanel>

      <TabPanel value={value} index={1}>
        <ClosedDataListComponent
          setClosedCount={setClosedCount}
        ></ClosedDataListComponent>
      </TabPanel>
    </>
  );
}

export default AuditTabComponent;
